import React from "react";
import Dialog from "@mui/material/Dialog";
import DialogTitle from "@mui/material/DialogTitle";
import DialogContent from "@mui/material/DialogContent";
import DialogActions from "@mui/material/DialogActions";
import Button from "@mui/material/Button";
import Typography from "@mui/material/Typography";
import {useSxStyles as sx} from "../styles/sxStyles";



const SessionTimeoutDialog = ({  open, countdown, onLogout,onContinue }) => {

    return (
        <Dialog
            open={open}
            maxWidth='md'
            fullWidth
            sx={sx.dialog}
            scroll="paper"
            aria-labelledby="scroll-dialog-title"
            aria-describedby="scroll-dialog-description"
        >
            <DialogTitle id="scroll-dialog-title" >
                <Typography variant="h5" color='primary'>
                    Session Expiration
                </Typography>
            </DialogTitle>
            <DialogContent dividers>
                <Typography variant="body2">
                    The current session is about to expire in{" "}
                    <span style={{color: 'red'}}>{countdown}</span> seconds.
                </Typography>
                <Typography variant="body2">{`Would you like to continue the session?`}</Typography>
            </DialogContent>
            <DialogActions>
                <Button onClick={onLogout} variant="contained" color="primary" sx={sx.button}>
                    Logout
                </Button>
                <Button onClick={onContinue} color="primary" variant="contained" sx={sx.button}>
                    Continue Session
                </Button>
            </DialogActions>
        </Dialog>
    );
}


export default SessionTimeoutDialog;
